import React from 'react';
import { createPortal } from 'react-dom';
import { PathwayExportBundle } from '../../types/pathway';
import { BundleDocument } from './BundleDocument';
interface BundlePrintSurfaceProps {
  bundle: PathwayExportBundle;
}
export function BundlePrintSurface({
  bundle
}: BundlePrintSurfaceProps) {
  if (typeof document === 'undefined') return null;
  return createPortal(<div className="pathway-print-root" aria-hidden="true" data-id="element-1531" data-mp="2rj6ie86wjfza"><BundleDocument bundle={bundle} data-id="element-1532" data-mp="2wjkuc1bmja2l" /></div>, document.body);
}